import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { AuthenticationService } from "src/app/services/authentication.service";
import { LTInfoRoleEnum } from "src/app/shared/generated/enum/l-t-info-role-enum";

/**
 * Gates pages reserved to users who can view project updates and propose projects —
 * `/projects/my`, `/projects/proposed`, `/project-updates`. Mirrors legacy
 * `ProjectUpdateViewAndCanProposeProjectFeature`: the user must have an LTInfo role
 * other than Unassigned. Anonymous and Unassigned users are redirected to the full
 * project list, matching the legacy controller's redirect to `Project.FullProjectList`.
 */
@Injectable({ providedIn: "root" })
export class ProjectUpdateViewAccessGuard implements CanActivate {
    constructor(private authenticationService: AuthenticationService, private router: Router) {}

    canActivate(): Observable<boolean> {
        return this.authenticationService.getCurrentUser().pipe(
            take(1),
            map((user) => {
                const allowed = user?.LTInfoRoleID != null && user.LTInfoRoleID !== LTInfoRoleEnum.Unassigned;
                if (!allowed) {
                    this.router.navigate(["/projects/all"]);
                    return false;
                }
                return true;
            })
        );
    }
}
